import { lazy } from 'react'

export const KitPageContainer = lazy(() => import('./KitPageContainer'))
export const PageContainer = lazy(() => import('./PageContainer'))
